import { useState } from 'react'; 

export default function AdminLogin({ className, setAdminMode }) {
    const [adminPass, setAdminPass] = useState(''); 
    const [showAdminPass, setShowAdminPass] = useState(false); 
    const [disableLogin, setDisableLogin] = useState(false); 

    const handleAdminLogin = e => {
        e.preventDefault(); 
        if (adminPass === process.env.REACT_APP_ADMIN_PASSWORD) {
            setAdminMode(true); 
            setAdminPass(''); 
            console.log("ADMIN MODE ON"); 
        } 
    }; 

    return (
        <div className={className}>
            <label tabIndex={0} htmlFor="admin-login" className="p-1 justify-center items-center h-14 w-14 btn btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                    <path fillRule="evenodd" d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                </svg>
            </label>
            <input type="checkbox" id="admin-login" className="modal-toggle" /> 
            <label htmlFor="admin-login" className="modal">
                <label className="modal-box relative" htmlFor="">
                    <label htmlFor="admin-login" className="absolute top-2 right-2 btn btn-sm btn-square">✕</label> 
                    <h3 className="mb-3 text-lg font-bold">Admin Panel</h3> 
                    <div className="flex justify-between items-end">
                        <div className="form-control">
                            <input type={showAdminPass ? "text" : "password"} className="input input-secondary border-2" placeholder="Password" value={adminPass} onChange={e => setAdminPass(e.target.value)} /> 
                            <label className="label cursor-pointer">
                            <span className="label-text">Show password</span>
                            <input className="checkbox checkbox-secondary" type="checkbox" checked={showAdminPass} onClick={e => setShowAdminPass(e.target.checked)} /> 
                            </label>
                        </div>
                        <button className={`ml-auto mt-3 btn ${(adminPass !== "") ? "btn-secondary" : "disabled"}`} disabled={adminPass === ""} onClick={handleAdminLogin}>Login</button> 
                    </div>
                </label>
            </label>
        </div>
    ); 
}